import { PlusOutlined } from "@ant-design/icons";
import { Button, Drawer, Space, Popconfirm, Form, message, Modal } from "antd";
import { useState } from "react";
import "./drawer.css";
import { Icon } from "@iconify/react";

const DrawerPlat = (props) => {
  const showPopconfirm = () => {
    props.setDrawerDeleteStatus(true);
  };
  const handleCancel = () => {
    console.log("Clicked cancel button");
    props.setDrawerDeleteStatus(false);
  };

  return (
    <>
      <Modal
        title={props.title}
        width="40%"
        height="75%"
        className="spp-invoice-form"
        onClose={props.changeDrawerStatus}
        onCancel={props.changeDrawerStatus}
        closable={true}
        open={props.drawerstatus}
        footer={null}
        style={{
          overflowY: "auto",
        }}
        extra={
          <>
            {props.deletestatus && (
              <Popconfirm
                title="Are you sure to delete?"
                open={props.drawerdeletestatus}
                onConfirm={props.rowDelete}
                okButtonProps={{
                  loading: props.confirmLoading,
                }}
                onCancel={handleCancel}
                placement="bottomRight"
              >
                <div>
                  <Icon
                    icon="material-symbols:delete"
                    className="drawer-delete-icon"
                    onClick={showPopconfirm}
                  />
                </div>
              </Popconfirm>
            )}
          </>
        }
      >
        {props.children}
      </Modal>
    </>
  );
};
export default DrawerPlat;
